module.exports = __webpack_public_path__ + "static/media/19-rettssak.73833f6c.mp3";